import React, {useContext, useEffect, useMemo, useState, memo} from "../../../../../../__snowpack__/pkg/react.js";
import {message, Modal, Tooltip, Upload} from "../../../../../../__snowpack__/pkg/antd.js";
import styled from "../../../../../../__snowpack__/pkg/styled-components.js";
import {isEmpty} from "../../../../../../__snowpack__/pkg/lodash.js";
import {IconPlus} from "../../../../../../__snowpack__/pkg/@genieui-react/icon.js";
import {checkImageRatio, checkImageWH} from "../../../../../components/uploaderUtils.js";
import {ImageSpinner} from "../../../../../components/ImageSpinner.js";
import LocaleContext from "../../../../../../__snowpack__/pkg/antd/es/locale-provider/context.js";
import {SessionHelper} from "../../../../../../__snowpack__/pkg/@genie/lib-iam-utils.js";
const i18n = {
  "zh-cn": {
    invalidSizeMsg: "\u56FE\u7247\u5FC5\u987B\u662FJPG\u3001PNG\u683C\u5F0F\uFF0C\u6700\u59274MB",
    invalidWhMsg: "\u5206\u8FA8\u7387\uFF1A600*600px\uFF5E1024*1024px"
  },
  en: {
    invalidSizeMsg: "Image must be JPG, PNG format, max. 4MB",
    invalidWhMsg: "Resolution: 600*600px\uFF5E1024*1024px"
  },
  id: {
    invalidSizeMsg: "Gambar harus dalam format JPG, PNG, maks. 4MB",
    invalidWhMsg: "Resolusi: 600*600px\uFF5E1024*1024px"
  },
  vi: {
    invalidSizeMsg: "H\xECnh \u1EA3nh b\u1EAFt bu\u1ED9c l\xE0 \u0111\u1ECBnh d\u1EA1ng JPG, PNG, t\u1ED1i \u0111a 4MB",
    invalidWhMsg: "\u0110\u1ED9 ph\xE2n gi\u1EA3i: 600 * 600px \uFF5E 1024 * 1024px"
  },
  th: {
    invalidSizeMsg: "\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A JOG, PNG, \u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 4MB",
    invalidWhMsg: "\u0E04\u0E27\u0E32\u0E21\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14: 600*600px\uFF5E1024*1024px	"
  }
};
const extname = (url = "") => {
  const temp = url.split("/");
  const filename = temp[temp.length - 1];
  const filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [""])[0];
};
const isImageFileType = (type) => type.indexOf("image/") === 0;
export const isImageUrl = (file) => {
  if (file.type) {
    return isImageFileType(file.type);
  }
  const url = file.thumbUrl || file.url;
  const extension = extname(url);
  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico|image)$/i.test(extension)) {
    return true;
  }
  if (/^data:/.test(url)) {
    return false;
  }
  if (extension) {
    return false;
  }
  return true;
};
const UploadCertification = memo((props) => {
  const {locale} = useContext(LocaleContext);
  const [state, setStateRaw] = useState({
    previewVisible: false,
    previewImage: "",
    previewTitle: "",
    fileList: []
  });
  const setState = (state2) => {
    setStateRaw(state2);
  };
  const curRequiredLabel = useMemo(() => {
    if (!isEmpty(props.requiredLabel) && typeof props.requiredLabel === "string") {
      return props.requiredLabel;
    }
    if (typeof props.requiredLabel === "function") {
      return props.requiredLabel(state.fileList.length);
    }
  }, [props.requiredLabel, state.fileList]);
  const handleCancel = () => {
    setState({...state, previewVisible: false});
  };
  const handlePreview = async (file) => {
    setState({
      ...state,
      previewImage: file.response || file.url || file.thumbUrl,
      previewVisible: true,
      previewTitle: file.name || (file.url || "").substring((file.url || "").lastIndexOf("/") + 1)
    });
  };
  const handleChange = ({file, fileList: fileList2}) => {
    setState({
      ...state,
      fileList: fileList2.filter((_) => _.status)
    });
    if (file.response) {
      props.onChange && props.onChange(fileList2);
    }
  };
  useEffect(() => {
    setStateRaw({
      ...state,
      fileList: [...props.value || []]
    });
  }, [props.value]);
  const {previewVisible, previewImage, fileList, previewTitle} = state;
  const uploadButton = /* @__PURE__ */ React.createElement("div", {
    className: "uploader-button",
    id: !curRequiredLabel ? props.id : void 0
  }, /* @__PURE__ */ React.createElement(IconPlus, {
    primaryColor: "#7F8FA4",
    style: {display: "block", width: 21, height: 21}
  }), curRequiredLabel && /* @__PURE__ */ React.createElement(Tooltip, {
    title: curRequiredLabel,
    placement: "topLeft"
  }, /* @__PURE__ */ React.createElement("div", {
    id: props.id,
    className: "upload-button-title"
  }, curRequiredLabel)));
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className: "uploader"
  }, /* @__PURE__ */ React.createElement(Upload, {
    accept: "image/jpeg,image/png,image/jpg,.pdf",
    headers: {Authorization: SessionHelper.getSessionToken() ?? ""},
    isImageUrl,
    data: props.otherData,
    disabled: props.disabled,
    name: "file",
    action: "/saas/product/v2/upload/upload-file",
    listType: "picture-card",
    fileList,
    itemRender: (node, file, fileList2) => {
      return /* @__PURE__ */ React.createElement("div", {
        className: "uploader-item"
      }, node, /* @__PURE__ */ React.createElement(Tooltip, {
        title: file.name,
        placement: "topLeft"
      }, /* @__PURE__ */ React.createElement("div", {
        className: "upload-item-title"
      }, props.itemTitleRender ? props.itemTitleRender(file, fileList2) : file.name)));
    },
    beforeUpload: async (file) => {
      const imageType = ["image/jpeg", "image/png", "image/jpg"];
      if (imageType.includes(file.type)) {
        if (props.limitWH) {
          try {
            await checkImageWH(file, props.limitWH[0], props.limitWH[1]);
          } catch (error) {
            message.error(props.invalidWhMsg || i18n[locale].invalidWhMsg);
            return Promise.reject("Invalid WH");
          }
        }
        if (props.limitMaxWH) {
          try {
            await checkImageWH(file, props.limitMaxWH[0], props.limitMaxWH[1], true);
          } catch (error) {
            message.error(props.invalidWhMsg || i18n[locale].invalidWhMsg);
            return Promise.reject("Invalid WH");
          }
        }
        if (props.limitRatio) {
          try {
            await checkImageRatio(file, props.limitRatio);
          } catch (error) {
            message.error(props.invalidWhMsg || i18n[locale].invalidWhMsg);
            return Promise.reject("Invalid WH");
          }
        }
        if (props.limitSizeM) {
          if (file.size / 1024 / 1024 > props.limitSizeM) {
            message.error(props.invalidSizeMsg || i18n[locale].invalidSizeMsg);
            return Promise.reject("Invalid Size");
          }
        }
      }
      return Promise.resolve(file);
    },
    onPreview: handlePreview,
    onChange: (files) => {
      let cvFiles = {...files};
      cvFiles.file = {
        ...cvFiles.file,
        response: cvFiles.file.response?.data || cvFiles.file.response
      };
      cvFiles.fileList = cvFiles.fileList?.map((data) => {
        return {
          ...data,
          ...props.otherParams,
          response: data?.response?.data || data?.response
        };
      });
      handleChange(cvFiles);
    },
    maxCount: props.limitNum,
    ...props.uploadProps
  }, fileList.length >= (props.limitNum || 1) ? null : uploadButton), /* @__PURE__ */ React.createElement(Modal, {
    destroyOnClose: true,
    visible: previewVisible,
    title: previewTitle,
    footer: null,
    width: props.modalWidth || 800,
    onCancel: handleCancel
  }, /* @__PURE__ */ React.createElement(ImageSpinner, {
    url: previewImage
  })));
});
export default UploadCertification;
const Wrapper = styled.div`
  &.uploader {
  }
  .uploader-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .upload-button-title {
      position: absolute;
      width: 100px;
      left: 0;
      bottom: -22px;
      font-size: 12px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: #7f8fa4;
      line-height: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .uploader-item {
    width: 100px;
    height: auto;
    .upload-item-title {
      display: block;
      text-align: center;
      margin-top: 8px;
      font-size: 12px;
      font-family: SFProText-Regular, SFProText;
      font-weight: 400;
      color: #7f8fa4;
      line-height: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .ant-upload-list-picture-card-container {
    width: 100px;
    height: auto;
    margin-right: 24px;
  }
  .ant-upload-list-picture-card .ant-upload-list-item {
    width: 100px;
    height: 100px;
  }
  .ant-upload.ant-upload-select-picture-card {
    position: relative;
    width: 100px;
    height: 100px;
    background: #fafdff;
    border-radius: 4px;
    border: 1px dashed #7f8fa4;
  }
`;
